import useEntities from 'hooks/useEntities';
import RelationsEditable from 'components/RelationsEditable';

const UserManagedTeams = ({ sourceEntityId, data, onChange }) => {
    const entities = useEntities();
    const sourceEntity = entities.User;
    const targetEntity = entities.Team;

    return (
        <RelationsEditable 
            data={data}
            sourceEntity={sourceEntity} 
            targetEntity={targetEntity}
            targetEntityAs="ManagedTeams"
            sourceEntityId={sourceEntityId}
            emptyMessage={`This ${sourceEntity.displayName} does not belong to any ${targetEntity.displayNamePlural}`}
            onChange={onChange}
        />
    )
}

export default UserManagedTeams
